import React from 'react';

import TimelineWrapper from '../../components/TimelineWrapper';
import TimelineContainer from '../../components/TimelineContainer';
import TimelineCard from '../../components/TimelineCard';

import iconCore from '../../assets/icon_core.svg';
import iconOffMarket from '../../assets/icon_off_market.svg';
import iconShield from '../../assets/icon_shield.svg';
import iconQuality from '../../assets/icon_quality.svg';
import iconTenancy from '../../assets/icon_tenancy.svg';
import iconCheck from '../../assets/Icon_check.svg';
import iconMobile from '../../assets/icon_mobile.svg';
import iconPartner from '../../assets/icon_partner.svg';

const HowItWorks = () => {
  return (
    <TimelineWrapper>
      <TimelineContainer
        heading="1-7 Days"
      >
        <TimelineCard
          icon={iconCore}
          heading="Step 1"
          body="As a sponsor, you will provide us with a company overview/management presentation, track record and deal specific information. This includes an excel of the financial model with cash-flow and waterfalls for the deal and the broker Offering Memorandum."
        />
        <TimelineCard
          icon={iconOffMarket}
          heading="Step 2"
          body="Our internal team will review your submission and prepare the transaction to go through the first level of our investment committee approvals. We will share their initial feedback on the transaction with you within 3-5 business days."
        />
      </TimelineContainer>
      <TimelineContainer
        heading="7-18 Days"
      >
        <TimelineCard
          icon={iconShield}
          heading="Step 3"
          body="Once we’ve received positive first level feedback from our investment committee, you will need to provide additional due diligence items for the property. We will also request background, credit and criminal reports for all your managing members. At this time, we will also go over all legal terms and agreements necessary to invest equity capital."
        />
        <TimelineCard
          icon={iconQuality}
          heading="Step 4"
          body="We will then proceed to our second stage of underwriting, preparing a “Green Light Memo” for internal review. Once we are approved on structure, we will execute the term sheet and schedule a site visit."
        />
      </TimelineContainer>
      <TimelineContainer
        heading="18-30 Days"
      >
        <TimelineCard
          icon={iconTenancy}
          heading="Step 5"
          body="We will do a site visit at the property with you and your property management team."
        />
        <TimelineCard
          icon={iconCheck}
          heading="Step 6"
          body="After our site visit, we will get final investment committee approval on the full credit memo and schedule a closing call with you to formalize funding into escrow prior to the close of the transaction."
        />
      </TimelineContainer>
      <TimelineContainer
        heading="30-45 Days"
      >
        <TimelineCard
          icon={iconMobile}
          heading="Step 7"
          body="It is now time to post your investment opportunity on our website. As part of content for our investors on the page, we will schedule a webinar with you to go over the details of the deal."
        />
        <TimelineCard
          icon={iconPartner}
          heading="Time to close"
          body="We fund our investment dollars into escrow and work with you to close the transaction."
        />
      </TimelineContainer>
    </TimelineWrapper>
  );
};

export default HowItWorks;
